import React from "react";
import { ScreenLabel } from "./ScreenLabel.js";
import { WorldLabel } from "./WorldLabel.js";
import { StaticTextLabel } from "./StaticTextLabel.js";
import { StaticImageLabel } from "./StaticImageLabel.js";
import {
  getDrawerStatePreserved,
  getLabelDrawerKey,
  getTypeDrawerOpen,
  setDrawerStatePreserved,
  setTypeDrawerOpen,
} from "./drawerState.js";

class LabelItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  render() {
    const toggleOpen = () => {
      this.setState({ open: !this.state.open });
    };

    let LabelHeader = () => {
      return <div>Label Header</div>;
    };
    let LabelDrawer = () => {
      return <div>Label Drawer</div>;
    };

    if (this.props.children.length == 2) {
      LabelHeader = this.props.children[0];
      LabelDrawer = this.props.children[1];
    }

    return (
      <div className="LabelItem">
        <LabelHeader toggleOpen={toggleOpen} isOpen={this.state.open} />
        {this.state.open ? (
          <div className="LabelItemDrawer">
            <LabelDrawer />
          </div>
        ) : null}
      </div>
    );
  }
}

class LabelTypeDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: getTypeDrawerOpen(props.drawerKey),
    };
  }

  toggleOpen() {
    this.setState((state, props) => {
      const open = !state.open;
      setTypeDrawerOpen(props.drawerKey, open);
      return { open };
    });
  }

  render() {
    let children = this.props.children;
    if (children.length == 0) {
      children = (() => {
        <div style={{ padding: "5px" }}>No Entries</div>;
      })();
    }
    return (
      <div className="LabelTypeDrawer">
        <div
          className="LabelTypeDrawerHeader"
          onClick={() => this.toggleOpen()}>
          <span className="PanelOpenStatus">{this.state.open ? "▾" : "▸"}</span>
          <span style={{ flex: 1 }}>{this.props.name}</span>
          <button
            title="Add New Label"
            className="CreateNewLabelBtn"
            onClick={(e) => {
              e.stopPropagation();
              this.props.handleCreate();
            }}>
            <i className="material-icons notranslate">add</i>
          </button>
        </div>
        {this.state.open ? <div className="LabelTypeDrawerContent">{children}</div> : null}
      </div>
    );
  }
}

class WorldLabelTypeDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: getTypeDrawerOpen(props.drawerKey),
    };
  }

  toggleOpen() {
    this.setState((state, props) => {
      const open = !state.open;
      setTypeDrawerOpen(props.drawerKey, open);
      return { open };
    });
  }

  render() {
    let children = this.props.children;
    if (children.length == 0) {
      children = (() => {
        <div style={{ padding: "5px" }}>No Entries</div>;
      })();
    }
    return (
      <div className="LabelTypeDrawer">
        <div
          className="LabelTypeDrawerHeader"
          onClick={() => this.toggleOpen()}>
          <span className="PanelOpenStatus">{this.state.open ? "▾" : "▸"}</span>
          <span style={{ flex: 1 }}>{this.props.name}</span>
          <div className="LabelTypeDrawerActions">
            <button
              title="Add Original Full-Canvas World Label"
              className="CreateNewLabelBtn"
              onClick={(e) => {
                e.stopPropagation();
                this.props.handleCreateCanvasWorld();
              }}>
              <i className="material-icons notranslate">add</i>
            </button>
            <button
              title="Add New Renderer World Label"
              className="CreateNewLabelBtn CreateNewLabelBtn--new-world-renderer"
              onClick={(e) => {
                e.stopPropagation();
                this.props.handleCreateNewRendererWorld();
              }}>
              <i className="material-icons notranslate">add</i>
            </button>
          </div>
        </div>
        {this.state.open ? <div className="LabelTypeDrawerContent">{children}</div> : null}
      </div>
    );
  }
}

class StaticLabelTypeDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: getTypeDrawerOpen(props.drawerKey),
    };
  }

  toggleOpen() {
    this.setState((state, props) => {
      const open = !state.open;
      setTypeDrawerOpen(props.drawerKey, open);
      return { open };
    });
  }

  render() {
    let children = this.props.children;
    if (children.length == 0) {
      children = (() => {
        <div style={{ padding: "5px" }}>No Entries</div>;
      })();
    }
    return (
      <div className="LabelTypeDrawer">
        <div
          className="LabelTypeDrawerHeader"
          onClick={() => this.toggleOpen()}>
          <span className="PanelOpenStatus">{this.state.open ? "▾" : "▸"}</span>
          <span style={{ flex: 1 }}>{this.props.name}</span>
          <div className="LabelTypeDrawerActions">
            <button
              title="Add New Static Text Label"
              className="CreateNewLabelBtn"
              onClick={(e) => {
                e.stopPropagation();
                this.props.handleCreateStaticText();
              }}>
              <i className="material-icons notranslate">text_fields</i>
            </button>
            <button
              title="Add New Static Image Label"
              className="CreateNewLabelBtn"
              onClick={(e) => {
                e.stopPropagation();
                this.props.handleCreateStaticImage();
              }}>
              <i className="material-icons notranslate">image</i>
            </button>
          </div>
        </div>
        <div style={{ marginLeft: "5px", backgroundColor: "#383838" }}>
          {this.state.open ? <div className="LabelTypeDrawerContent">{children}</div> : null}
        </div>
      </div>
    );
  }
}

function LabelDrawerCollection(props) {
  return (
    <div className="LabelDrawCollection">
      <LabelTypeDrawer drawerKey="screen" name="Screen Labels" handleCreate={props.handleCreate2D}>
        {props.screenLabels.map((label) => (
          <ScreenLabel key={label.id} labelDrawerKey={getLabelDrawerKey(label)} getLabels={props.getLabels} {...label} />
        ))}
      </LabelTypeDrawer>

      <WorldLabelTypeDrawer
        drawerKey="world"
        name="World Labels"
        handleCreateCanvasWorld={props.handleCreate3DCanvas}
        handleCreateNewRendererWorld={props.handleCreate3DNewRenderer}>
        {props.worldLabels.map((label) => (
          <WorldLabel key={label.id} labelDrawerKey={getLabelDrawerKey(label)} getLabels={props.getLabels} {...label} />
        ))}
      </WorldLabelTypeDrawer>

      <StaticLabelTypeDrawer
        drawerKey="static"
        name="Static Labels"
        handleCreateStaticText={props.handleCreateStaticText}
        handleCreateStaticImage={props.handleCreateStaticImage}>
        {props.staticTextLabels.map((label) => (
          <StaticTextLabel key={label.id} labelDrawerKey={getLabelDrawerKey(label)} getLabels={props.getLabels} {...label} />
        ))}
        {props.staticImageLabels.map((label) => (
          <StaticImageLabel key={label.id} labelDrawerKey={getLabelDrawerKey(label)} getLabels={props.getLabels} {...label} />
        ))}
      </StaticLabelTypeDrawer>

      {/* <LabelTypeDrawer name="Static Text Labels" handleCreate={props.handleCreateStaticText}>
        {props.staticTextLabels.map((label, index) => (
          <StaticTextLabel key={index} getLabels={props.getLabels} {...label} />
        ))}
      </LabelTypeDrawer>

      <LabelTypeDrawer name="Static Image Labels" handleCreate={props.handleCreateStaticImage}>
        {props.staticImageLabels.map((label, index) => (
          <StaticImageLabel key={index} getLabels={props.getLabels} {...label} />
        ))}
      </LabelTypeDrawer> */}
    </div>
  );
}

class LabelsEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listenerID: null,
      drawerStatePreserved: getDrawerStatePreserved(),
      drawerStateVersion: 0,
    };
    this.LABEL_TYPES = {
      "2D": "screenLabels",
      "3D": "worldLabels",
      STATIC_TEXT: "staticTextLabels",
      STATIC_IMAGE: "staticImageLabels",
      STATIC_TEXT_LABEL: "staticTextLabels",
      STATIC_IMAGE_LABEL: "staticImageLabels",
    };
    Object.keys(this.LABEL_TYPES).map((key) => {
      this.state[this.LABEL_TYPES[key]] = [];
    });
    this.getLabels = this.getLabels.bind(this);
    this.handleToggleDrawerState = this.handleToggleDrawerState.bind(this);
  }

  componentDidMount() {
    let listenerID = Inventum.labels.addUpdateListener(() => {
      this.getLabels();
    });
    this.setState({ listenerID }, () => {
      this.getLabels();
    });
  }

  componentWillUnmount() {
    Inventum.labels.removeUpdateListener(this.state.listenerID);
  }

  getLabels() {
    const labels = Inventum.labels.getLabels();
    const tState = {};
    Object.keys(this.LABEL_TYPES).map((key) => {
      tState[this.LABEL_TYPES[key]] = [];
    });

    labels.map((label) => {
      if (!Object.prototype.hasOwnProperty.call(this.LABEL_TYPES, label.type)) return;

      // Filter out figure text labels that have a parent (they'll be shown under the parent)
      if (label.type === "STATIC_TEXT_LABEL" && label.parentImageId) {
        return; // Skip, will be shown under parent image label
      }

      tState[this.LABEL_TYPES[label.type]].push(label);
    });
    this.setState(tState);
  }

  handleToggleDrawerState(e) {
    e.stopPropagation();

    const drawerStatePreserved = !this.state.drawerStatePreserved;
    setDrawerStatePreserved(drawerStatePreserved);
    this.setState((state) => ({
      drawerStatePreserved,
      drawerStateVersion: state.drawerStateVersion + 1,
    }));
  }

  render() {
    let style = {
      background: "#FFF",
      pointerEvents: "all",
    };

    const handleCreate2D = () => {
      Inventum.labels.create("2D");
      // 2D Labels are almost always visible
      this.getLabels();
    };

    const handleCreate3DCanvas = () => {
      let id = Inventum.labels.create("3D", { textRenderer: "canvas" });
      Inventum.labels.toggleVisible(id);
      this.getLabels();
    };

    const handleCreate3DNewRenderer = () => {
      let id = Inventum.labels.create("3D", { textRenderer: "sdf" });
      Inventum.labels.toggleVisible(id);
      this.getLabels();
    };

    const handleCreateStaticText = () => {
      let id = Inventum.labels.create("STATIC_TEXT_LABEL");
      Inventum.labels.toggleVisible(id);
      this.getLabels();
    };

    const handleCreateStaticImage = () => {
      let id = Inventum.labels.create("STATIC_IMAGE_LABEL");
      Inventum.labels.toggleVisible(id);
      this.getLabels();
    };

    const handleHelp = (e) => {
      e.stopPropagation();
      window.open("https://docs.inventum3d.com/labels/", "_blank");
    };

    const drawerStatePreserved = this.state.drawerStatePreserved;

    return (
      <div className="LabelsPanel">
        <div className="EditorTabHeader">
          <div className="EditorTabTitle">
            <i className="material-icons notranslate">label</i>
            <span>Labels</span>
          </div>
          <div className="EditorTabHeaderActions">
            <button
              className={`EditorTabHelpButton EditorTabToggleButton${drawerStatePreserved ? " active" : ""}`}
              title={drawerStatePreserved ? "Drawer state preservation is on" : "Drawer state preservation is off"}
              aria-pressed={drawerStatePreserved}
              onClick={this.handleToggleDrawerState}>
              <i className="material-icons notranslate">{drawerStatePreserved ? "unfold_more" : "unfold_less"}</i>
            </button>
            <button className="EditorTabHelpButton" title="Opens the Inventum Docs" onClick={handleHelp}>
              <i className="material-icons notranslate">help</i>
            </button>
          </div>
        </div>
        <LabelDrawerCollection
          key={this.state.drawerStateVersion}
          handleCreate2D={handleCreate2D}
          handleCreate3DCanvas={handleCreate3DCanvas}
          handleCreate3DNewRenderer={handleCreate3DNewRenderer}
          handleCreateStaticText={handleCreateStaticText}
          handleCreateStaticImage={handleCreateStaticImage}
          screenLabels={this.state.screenLabels}
          getLabels={this.getLabels}
          worldLabels={this.state.worldLabels}
          staticTextLabels={this.state.staticTextLabels}
          staticImageLabels={this.state.staticImageLabels}
        />
      </div>
    );
  }
}

export default LabelsEditor;